import React, { useState, useEffect } from "react";
import { IconPlus, IconSearch } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { useUnitList, useDepartmentList } from "hooks";

const HeadingDetail = ({
  form,
  onChangeSearchInput,
  onChangeUnitDropdown,
  onChangeDepartmentDropdown,
  onOpenEditAdminDialog,
  selectedUsers,
  onRemoveAdmin,
}) => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const { totalUnitList } = useUnitList();
  const { departmentList, handleToggleShowDepartment } = useDepartmentList();

  const [unitList, setUnitList] = useState([]);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [filterDepartmentList, setFilterDepartmentList] = useState([]);

  useEffect(() => {
    if (totalUnitList) {
      setUnitList(
        [
          { unitId: 0, unitName: getLabel(LangConstant.TXT_FILTER_ALL) },
          { unitId: -1, unitName: getLabel(LangConstant.TXT_FILTER_OTHER) },
        ].concat(
          [...totalUnitList].sort((a, b) => {
            return (a.unitName || "").localeCompare(b.unitName || "", "vi");
          }),
        ),
      );
    }
  }, [totalUnitList]);

  useEffect(() => {
    if (departmentList && Object.keys(departmentList).includes(selectedUnitId)) {
      setFilterDepartmentList(
        [
          { departmentId: 0, departmentName: getLabel(LangConstant.TXT_FILTER_ALL) },
          { departmentId: -1, departmentName: getLabel(LangConstant.TXT_FILTER_OTHER) },
        ].concat(
          [...departmentList[selectedUnitId]].sort((a, b) => {
            return (a.departmentName || "").localeCompare(b.departmentName || "", "vi");
          }),
        ),
      );
    } else {
      setFilterDepartmentList([
        { departmentId: 0, departmentName: getLabel(LangConstant.TXT_FILTER_ALL) },
        { departmentId: -1, departmentName: getLabel(LangConstant.TXT_FILTER_OTHER) },
      ]);
    }
  }, [departmentList, selectedUnitId]);

  const onChangeUnit = e => {
    setSelectedUnitId(e.target.value);
    onChangeUnitDropdown(e);
    handleToggleShowDepartment(e.target.value);
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
      <div className="d-flex align-items-center" style={{ width: 1000 }}>
        <div className="input-group" style={{ flex: 1 }}>
          <input
            type="text"
            className="form-control"
            defaultValue={form.search}
            onChange={onChangeSearchInput}
            placeholder={getLabel(LangConstant.P_ADD_NEW_USER)}
          />
          <span className="input-group-text">
            <IconSearch size={16} />
          </span>
        </div>

        <div style={{ marginLeft: 8, width: 320 }}>
          <select
            className="form-select"
            value={form.unitId}
            onChange={e => onChangeUnit(e)}
          >
            {unitList.map(data => (
              <option key={data.unitId} value={data.unitId}>
                {data.unitName}
              </option>
            ))}
          </select>
        </div>
        <div style={{ marginLeft: 8, width: 320 }}>
          <select
            className="form-select"
            value={form.departmentId}
            onChange={onChangeDepartmentDropdown}
          >
            {filterDepartmentList.map(data => (
              <option key={data.departmentId} value={data.departmentId}>
                {data.departmentName}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end gap-2">
        <button
          className="btn btn-danger"
          disabled={selectedUsers.length === 0}
          onClick={() => onRemoveAdmin()}
        >
          {getLabel(LangConstant.TXT_DELETE_ADMIN)}
        </button>
        <button className="btn btn-primary" onClick={onOpenEditAdminDialog}>
          <IconPlus size={16} className="me-1" />
          {getLabel(LangConstant.TXT_ADD_ADMIN)}
        </button>
      </div>
    </div>
  );
};

export default HeadingDetail;
